import { useEffect, useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import type { AdminPlan } from '../../../services/admin';
import styles from './AnnouncementsTab.module.css';

interface PlanMultiSelectProps {
    id: string;
    plans: AdminPlan[];
    selected: string[];
    onToggle: (planId: string) => void;
    onClear: () => void;
}

function buttonLabel(plans: AdminPlan[], selected: string[]): string {
    if (selected.length === 0) return 'Todos os planos';
    if (selected.length > 2) return `${selected.length} planos selecionados`;
    return plans
        .filter((plan) => selected.includes(plan.id))
        .map((plan) => plan.name)
        .join(', ');
}

export function PlanMultiSelect({ id, plans, selected, onToggle, onClear }: PlanMultiSelectProps) {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!open) return;
        const handleEscape = (e: KeyboardEvent) => {
            if (e.key === 'Escape') setOpen(false);
        };
        document.addEventListener('keydown', handleEscape);
        return () => document.removeEventListener('keydown', handleEscape);
    }, [open]);

    return (
        <div className={styles.multiSelect}>
            <button
                id={id}
                type="button"
                className={styles.multiSelectButton}
                aria-haspopup="listbox"
                aria-expanded={open}
                onClick={() => setOpen((current) => !current)}
            >
                <span className={styles.multiSelectValue}>{buttonLabel(plans, selected)}</span>
                <FiChevronDown size={16} />
            </button>

            {open && (
                <>
                    <div className={styles.multiSelectBackdrop} onClick={() => setOpen(false)} />
                    <div className={styles.multiSelectPanel} role="listbox" aria-multiselectable="true">
                        {plans.map((plan) => (
                            <label key={plan.id} className={styles.multiSelectOption}>
                                <input
                                    type="checkbox"
                                    checked={selected.includes(plan.id)}
                                    onChange={() => onToggle(plan.id)}
                                />
                                {plan.name}
                            </label>
                        ))}
                        <button
                            type="button"
                            className={styles.multiSelectClear}
                            disabled={selected.length === 0}
                            onClick={onClear}
                        >
                            Limpar seleção
                        </button>
                    </div>
                </>
            )}
        </div>
    );
}
